<template>
    <CModal :visible="showModal" size="xl" alignment="top" @close="showModal=false" backdrop="static">
        <CModalHeader>
            <CModalTitle>Artikel bearbeiten</CModalTitle>
        </CModalHeader>
        <CModalBody>
            <div class="row">
                <div class="col mb-3">
                    <input-field name="artnr" label="Artikelnummer" :class="disabled" readonly disabled v-model="article.artnr" :errors="errors" placeholder="wird autom. generiert"></input-field>
                </div>
                <div class="col mb-3">
                    <input-field name="title" required label="Bezeichnung" v-model="article.title" :errors="errors"></input-field>
                </div>
                <div class="col mb-3">
                    <input-field name="version" required label="Version" v-model="article.version" :errors="errors"></input-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#price-tab-pane"
                                    type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Preise
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#settings-tab-pane"
                                    type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Eigenschaften
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#options-tab-pane"
                                    type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Optionen/Regeln
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#html-tab-pane"
                                  type="button" role="tab" aria-controls="html-tab-pane" aria-selected="true">HTML-Text
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#img-tab-pane"
                                  type="button" role="tab" aria-controls="img-tab-pane" aria-selected="true">Bilder
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#media-tab-pane"
                                  type="button" role="tab" aria-controls="media-tab-pane" aria-selected="true">Medien
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#atts-tab-pane"
                                  type="button" role="tab" aria-controls="atts-tab-pane" aria-selected="true">Attribute
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#text-tab-pane"
                                  type="button" role="tab" aria-controls="text-tab-pane" aria-selected="true">Text für Angebote
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#notice-tab-pane"
                                    type="button" role="tab" aria-controls="notice-tab-pane" aria-selected="true">Notizen
                            </button>
                        </li>
                    </ul>
                    <div class="tab-content flex-grow-1 border border-top-0 p-3" id="myTabContent" style="min-height: 0; overflow: auto;">
                        <div class="tab-pane h-100 fade show" id="atts-tab-pane" role="tabpanel" aria-labelledby="overview-tab">
                          <div class="row bg-dark text-white">
                            <div class="col text-center" style="font-weight: bold;">Attribut</div>
                            <div class="col text-center"
                                 style="font-weight: bold;"
                                 v-for="lang in $store.state.webshop.languages" :key="lang.code"
                            >
                              {{ lang.label }}
                            </div>
                            <div class="col-auto text-center"><button class="btn btn-outline-danger btn-xs invisible" :disabled="true"><i class="fa-solid fa-trash"></i></button></div>
                          </div>
                          <template v-for="(attribute, index) in article.attributes" :key="index">
                            <div class="row align-items-center">
                              <div class="col">
                                <select class="form-select form-control-xs" v-model="attribute.attribute_id">
                                  <template v-for="category in $store.state.attributes" :key="category.category">
                                    <optgroup :label="category.category">
                                      <template v-for="(attribute, index) in category.items" :key="index">
                                        <option :value="index" :disabled="isUsedOption(index, attribute.attribute_id)">{{attribute}}</option>
                                      </template>
                                    </optgroup>
                                  </template>
                                </select>
                              </div>
                              <div class="col" v-for="lang in $store.state.webshop.languages" :key="lang.code">
                                <input-field :name="`attribute.languages.${lang.code}`"
                                             class="form-control-xs"
                                             v-model="attribute.languages[lang.code]"  />
                              </div>
                              <div class="col-auto">
                                <button class="btn btn-outline-danger btn-xs" @click="removeRow(index)"><i class="fa-solid fa-trash"></i></button>
                              </div>
                            </div>
                          </template>
                          <div class="mt-3 text-end">
                            <button class="btn btn-primary" @click="addRow()"><i class="fa-solid fa-plus"></i> neues Attribut hinzufügen</button>
                          </div>
                        </div>

                      <div class="tab-pane h-100 fade show " id="html-tab-pane" role="tabpanel" aria-labelledby="overview-tab"
                           tabindex="0">
                        <div class="row justify-content-end">
                          <div class="col mb-3">
                            <input-field name="title" label="Artikeltitel" required v-model="title" />
                          </div>
                          <div class="col-4 mb-1">
                            <select-field name="" label="Sprache" v-model="selectedLanguage">
                              <template v-for="lang in $store.state.webshop.languages" :key="lang.code" >
                                <option :value="lang.code">{{lang.label}}</option>
                              </template>
                            </select-field>
                          </div>
                        </div>
                        <div class="mb-3">
                          <text-area-field name="shortDesc" required label="Kurzbeschreibung" v-model="shortdesc" minHeight="76px"/>
                        </div>
                        <template v-if="article && article.descriptions">
                          <QuillEditor
                            id="editor-1"
                            v-model:content="description"
                            contentType="html"
                            :toolbar="toolbarOptions"
                            style="height: 250px"
                          />
                        </template>
                      </div>
                      <div class="tab-pane h-100 fade show " id="img-tab-pane" role="tabpanel" aria-labelledby="overview-tab"
                           tabindex="0">
                            <div class="row" v-if="article">
                              <template v-for="image in article.images" :key="image.id">
                                <div class="col-3 h-100 mb-3 text-center">
                                  <div class="ratio ratio-1x1" style="max-width: 320px; background:#f8f9fa;">
                                    <img
                                      :src="image.paths.thumbnail"
                                      alt="…"
                                      class="w-100 h-100"
                                      style="object-fit: contain; object-position: center;"
                                      loading="lazy"
                                    >
                                  </div>
                                  <div class="text-muted small text-center">{{image.title}}</div>
                                </div>
                              </template>
                            </div>
                      </div>
                      <div class="tab-pane h-100 fade show " id="media-tab-pane" role="tabpanel" aria-labelledby="overview-tab"
                           tabindex="0">
                        <div class="row">
                            <template v-for="media in article.media" :key="media.id">
                              <div class="col-3 h-100 mb-3 text-center">
                                <div class="ratio ratio-1x1" style="max-width: 320px; background:#f8f9fa;">
                                  <a :href="media.paths.original" target="_blank">
                                    <img
                                      :src="media.paths.thumbnail"
                                      alt="…"
                                      class="w-100 h-100"
                                      style="object-fit: contain; object-position: center;"
                                      loading="lazy"
                                    >
                                  </a>
                                </div>
                                <div class="text-muted small text-center">{{media.title}}</div>
                              </div>
                            </template>
                        </div>
                      </div>

                        <div class="tab-pane h-100 fade show active " id="price-tab-pane" role="tabpanel" aria-labelledby="overview-tab"
                             tabindex="0">
                            <div class="row">
                                <div class="col-4">
                                    <div class="mb-3">
                                        <input-currency name="vkMin" required label="VK min."  v-model="article.vkMin" :errors="errors"></input-currency>
                                    </div>
                                    <div class="mb-3">
                                        <input-currency name="vkMinHB" required label="VK min. Händler/Behörde"  v-model="article.vkMinHB" :errors="errors"></input-currency>
                                    </div>
                                    <hr>
                                    <div class="mb-3">
                                        <input-currency name="priceEK" required label="EK max."  v-model="article.priceEK" :errors="errors"></input-currency>
                                    </div>
                                </div>
                              <div class="col-4">
                                <div class="mb-3">
                                  <input-currency name="priceA" label="Shoppreis Default"  v-model="article.price" :errors="errors" />
                                </div>
                                <div class="mb-3">
                                  <input-currency name="priceA" label="Shoppreis Endkunden"  v-model="article.priceA" :errors="errors"/>
                                </div>
                                <div class="mb-3">
                                  <input-currency name="priceB" label="Shoppreis Händler"  v-model="article.priceB"  :errors="errors"/>
                                </div>
                                <div class="mb-3">
                                  <input-currency name="priceC" label="Shoppreis Behörde"  v-model="article.priceC"  :errors="errors"/>
                                </div>
                              </div>
                                <div class="col mb-3">
                                  <div class="card h-100">
                                      <div class="card-header">
                                          <b>Optionen</b>
                                      </div>
                                      <div class="card-body">
                                        <div class="mb-3">
                                          <select-field name="unit" label="Mandant" required v-model="article.mandant_id" :errors="errors">
                                            <option :value="1">usedSoft Deutschland GmbH</option>
                                            <option :value="2">System Performance</option>
                                          </select-field>
                                        </div>
                                        <div class="mb-3">
                                          <select-field name="unit" label="Produkteinheit" required v-model="article.unit" :errors="errors">
                                            <option :value="'PER_PIECE'">Stück</option>
                                            <option :value="'PER_HOUR'">Arbeitsstunden</option>
                                            <option :value="'PER_DAY'">Arbeitstage</option>
                                            <option :value="'FLAT_RATE'">Pauschalpeis</option>
                                          </select-field>
                                        </div>
                                        <div class="input-group mb-3">
                                          <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" id="isActive" v-model="article.isActive" aria-label="Checkbox for following text input">
                                          </div>
                                          <label class="input-group-text flex-grow-1" for="isActive"> Artikel ist aktiv </label>
                                        </div>
                                        <div class="input-group mb-3">
                                          <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" id="isShopArticle" v-model="article.isShopArticle" aria-label="Checkbox for following text input">
                                          </div>
                                          <label class="input-group-text flex-grow-1" for="isShopArticle"> Artikel wird im Shop veröffentlicht</label>
                                        </div>
                                        <div class="input-group mb-3">
                                          <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" id="isShopActive" v-model="article.isShopActive" aria-label="Checkbox for following text input">
                                          </div>
                                          <label class="input-group-text flex-grow-1" for="isShopActive"> Artikel ist im Shop aktiv</label>
                                        </div>
                                        <div class="input-group mb-3">
                                          <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" id="isShopHidden" v-model="article.isShopHidden" aria-label="Checkbox for following text input">
                                          </div>
                                          <label class="input-group-text flex-grow-1" for="isShopHidden"> Artikel ist im Shop versteckt</label>
                                        </div>
                                        <hr>
                                        <div class="input-group mb-3">
                                          <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" id="isFoxway" readonly v-model="article.isFoxway" aria-label="Checkbox for following text input">
                                          </div>
                                          <label class="input-group-text flex-grow-1" for="isFoxway"> Artikel ist ein Foxway Artikel</label>
                                        </div>
                                        <div class="input-group">
                                          <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" id="commissionable" v-model="article.commissionable" aria-label="Checkbox for following text input">
                                          </div>
                                          <label class="input-group-text flex-grow-1" for="commissionable"> Artikel ist provisionsfähig</label>
                                        </div>
                                      </div>
                                  </div>

                                </div>

                            </div>
                        </div>
                        <div class="tab-pane h-100 fade show" id="settings-tab-pane" role="tabpanel" aria-labelledby="overview-tab"
                             tabindex="0">
                            <div class="row">
                                <div class="col mb-3">
                                    <select-field name="product_type" label="Produktart" required v-model="article.product_type" :errors="errors">
                                      <optgroup label="Software">
                                        <option value="license">Lizenz</option>
                                        <option value="subscription">Abo/Subscription</option>
                                        <option value="disk">MediaKit</option>
                                      </optgroup>
                                      <optgroup label="Andere">
                                          <option value="service">Dienstleistung</option>
                                          <option value="hardware">Hardware</option>
                                          <option value="embodiment">Verkörperung</option>
                                      </optgroup>
                                    </select-field>
                                </div>
                                <div class="col mb-3">
                                  <select-field name="license_type" label="Lizenztyp" required v-model="article.license_type" :errors="errors">
                                    <option value="volume">Volumenlizenz</option>
                                    <option value="single user">Arbeitsplatzlizenz</option>
                                    <option value="other">Keine Lizenz</option>
                                  </select-field>
                                </div>
                                <div class="col mb-3">
                                    <input-field name="producer" required label="Hersteller" v-model="article.producer" :errors="errors"></input-field>
                                </div>
                            </div>
                            <div class="row">

                              <div class="col mb-3">
                                <select-field name="mediakit_id" label="passendes Media Kit" :reset="true" :disabled="article.product_type == 'disk'" v-model="article.mediakit_id" :errors="errors">
                                    <template v-for="mediakit in mediakits" :key="mediakit.id">
                                      <option :value="mediakit.id">{{mediakit.artnr}} | {{mediakit.title}} {{mediakit.version}}</option>
                                    </template>
                                </select-field>
                              </div>
                                <div class="col mb-3">
                                    <select-field name="category_id" label="Kategorie" :reset="true" v-model="article.category_id" :errors="errors">
                                      <option v-for="category in $store.state.categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                                    </select-field>
                                </div>
                                <div class="col mb-3">
                                    <input-integer name="stockWarning" label="Mindestbestand" v-model="article.stockWarning" :errors="errors">
                                      <template #behind><div class="input-group-text">Stk.</div></template>
                                    </input-integer>
                                </div>
                            </div>
                            <div class="row">
                              <div class="col mb-3">
                                <input-field name="supplierReferenceNumber" label="Bestellnummer Lieferant" max-length="128" v-model="article.supplierReferenceNumber" :errors="errors"></input-field>
                              </div>
                              <div class="col mb-3">
                                <input-field name="producerReferenceNumber" label="Herstellernummer" max-length="128" v-model="article.producerReferenceNumber" :errors="errors"></input-field>
                              </div>
                              <div class="col mb-3">
                                <input-field name="ean" label="GTIN/EAN" max-length="128" v-model="article.ean" :errors="errors"></input-field>
                              </div>
                            </div>
                        </div>
                        <div class="tab-pane h-100 fade show" id="options-tab-pane" role="tabpanel" aria-labelledby="overview-tab"
                             tabindex="0">
                            <div class="row">
                                <div class="col">
                                    <div class="card h-100">
                                      <div class="card-header"><b><i class="fa-solid fa-file-pdf"></i> Kundenhinweise und Anhänge</b></div>
                                      <div  class="card-body">
                                        <div class="input-group mb-3">
                                          <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" id="pdf_standard" v-model="article.pdf_standard" aria-label="Checkbox for following text input">
                                          </div>
                                          <label class="input-group-text flex-grow-1" for="pdf_standard"><i class="fa-solid fa-triangle-exclamation fa-fw me-1"></i> erzwingt Zusatztext (Standard) auf dem LK-PDF</label>
                                        </div>
                                        <div class="input-group mb-3">
                                          <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" id="pdf_cal" v-model="article.pdf_cal" aria-label="Checkbox for following text input">
                                          </div>
                                          <label class="input-group-text flex-grow-1" for="pdf_cal"><i class="fa-solid fa-triangle-exclamation  fa-fw me-1"></i> erzwingt Zusatztext (CAL) auf dem LK-PDF</label>
                                        </div>
                                        <hr/>
                                        <div class="input-group mb-3">
                                          <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" id="pdf_installation" v-model="article.pdf_installation" aria-label="Checkbox for following text input">
                                          </div>
                                          <label class="input-group-text flex-grow-1" for="pdf_installation"><i class="fa-solid fa-file-pdf  fa-fw me-1"></i> Installationsanleitung wird angehängt</label>
                                        </div>
                                        <div class="input-group mb-3">
                                          <div class="input-group-text">
                                            <input class="form-check-input mt-0" type="checkbox" id="isKmsPossible" v-model="article.isKmsPossible" aria-label="Checkbox for following text input">
                                          </div>
                                          <label class="input-group-text flex-grow-1" for="isKmsPossible"><i class="fa-solid fa-key  fa-fw me-1"></i> KMS-Schlüssel ist möglich</label>
                                        </div>
                                      </div>
                                    </div>

                                </div>
                                <div class="col">
                                  <div class="card h-100">

                                          <div class="card-header">
                                              <b><i class="fa-solid fa-arrow-progress"></i> Regeln für autom. Zuordnung</b>
                                          </div>
                                          <div class="card-body">
                                            <div class="mb-3">
                                              <div class="input-group">
                                                <div class="input-group-text">
                                                  <input class="form-check-input mt-0" type="checkbox" id="noStockRequired" v-model="article.noStockRequired" aria-label="Checkbox for following text input">
                                                </div>
                                                <label class="input-group-text flex-grow-1" for="noStockRequired"> Artikel hat keine Lagerverwaltung</label>
                                              </div>
                                              <div id="passwordHelpBlock" class="form-text">
                                                z.B. für Arbeitsstunden
                                              </div>
                                            </div>
                                            <div class="mb-3">
                                                <div class="input-group">
                                                  <div class="input-group-text">
                                                    <input class="form-check-input mt-0" type="checkbox" id="noKeyRequired" v-model="article.noKeyRequired" aria-label="Checkbox for following text input">
                                                  </div>
                                                  <label class="input-group-text flex-grow-1" for="noKeyRequired"> Artikel benötigt keinen Lizenzschlüssel</label>
                                                </div>
                                            </div>
                                            <div class="mb-3" v-if="!article.noKeyRequired">
                                                <div class="input-group">
                                                  <div class="input-group-text">
                                                    <input class="form-check-input mt-0" type="checkbox" id="manuelKeySelection" v-model="article.manuelKeySelection" aria-label="Checkbox for following text input">
                                                  </div>
                                                  <label class="input-group-text flex-grow-1" for="manuelKeySelection"> manuelle Key-Auswahl aktivieren</label>

                                                </div>
                                                <div id="passwordHelpBlock" class="form-text">
                                                  Bei Aktivierung muss die Key-Zuweisung immer manuell erfolgen.
                                                </div>
                                            </div>


                                            <div class="mb-3" v-if="!article.noKeyRequired && !article.manuelKeySelection">
                                              <input-integer name="manuelKeySelectionByAmount" :options="options" :disabled="!isManuelKeySelectionByAmountActive" v-model="article.manuelKeySelectionByAmount" :errors="errors" label="Manuelle Key-Auswahl, wenn mehr als X Lizenzen bestellt" >
                                                <div class="input-group-text">
                                                  <input class="form-check-input mt-0" type="checkbox" v-model="isManuelKeySelectionByAmountActive">
                                                </div>
                                                <template #behind><div class="input-group-text">Stk.</div></template>
                                              </input-integer>
                                              <div id="passwordHelpBlock" class="form-text">
                                                Key muss manuell zugewiesen werden, wenn die Lizenzanzahl <u><b>größer</b></u> als die angegeben Anzahl ist.
                                              </div>
                                            </div>
                                            <hr/>
                                            <div class="mb-3">
                                              <input-integer name="minLicensce" :options="options" :disabled="!article.autostopAmountSmallerThan" v-model="article.minLicensce" :errors="errors" label="Manuelle Auftragsfreigabe aktiveren, wenn Mindestlizenzanzahl unterschritten wird" >
                                                <div class="input-group-text">
                                                  <input class="form-check-input mt-0" type="checkbox" v-model="article.autostopAmountSmallerThan">
                                                  <!--<div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="article.autostopAmountSmallerThan">
                                                    <label class="form-check-label" for="flexSwitchCheckDefault">Default switch checkbox input</label>
                                                  </div>-->
                                                </div>
                                                <template #behind><div class="input-group-text">Stk.</div></template>
                                              </input-integer>
                                              <div id="passwordHelpBlock" class="form-text">
                                                Auftrag muss manuell bestätigt werden, wenn die Lizenzanzahl die Mindestlizenzmenge unterschreitet (z.B. Windows Server).
                                              </div>
                                            </div>
                                          </div>
                                      </div>


                                </div>
                            </div>
                        </div>
                        <div class="tab-pane h-100 fade show" id="text-tab-pane" role="tabpanel" aria-labelledby="overview-tab"
                             tabindex="0">
                          <text-area-field label="Text-Template" v-model="article.text" :errors="errors" ></text-area-field>
                        </div>
                        <div class="tab-pane h-100 fade show" id="notice-tab-pane" role="tabpanel" aria-labelledby="overview-tab"
                             tabindex="0">
                            <text-area-field label="Notizen" v-model="article.notice" :errors="errors" ></text-area-field>
                        </div>
                    </div>
                </div>
            </div>


        </CModalBody>
        <CModalFooter>
            <div class="col text-end">
                <button class="btn btn-outline-dark btn-sm me-3" @click="showModal=false">Abbrechen</button>
                <button class="btn btn-primary btn-sm" @click="save()" v-if="action=='edit'">Speichern</button>
                <button class="btn btn-primary btn-sm" @click="create()" v-if="action=='create'">Erstellen</button>
            </div>
        </CModalFooter>
    </CModal>
</template>

<script>
import {CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle} from "@coreui/bootstrap-vue";
import {isDisabled} from "bootstrap/js/src/util";
import InputField from "@/components/inputField.vue";
import CompanyTabOverview from "@/pages/crm/CompanyTabOverview.vue";
import InputCurrency from "@/components/inputCurrency.vue";
import SelectField from "@/components/selectField.vue";
import TextAreaField from "@/components/textAreaField.vue";
import eventBus from "@/eventBus";
import InputInteger from "@/components/inputInteger.vue";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
    name: "modalArticle",
    components: {
        InputInteger,
        TextAreaField,
        SelectField,
        InputCurrency,
        CompanyTabOverview,
        InputField,
        CModal, CModalBody,
        CModalFooter,
        CModalHeader,
        CModalTitle,
        QuillEditor
    },
    props: {
        shown: Boolean,
        modus: {
            type: Object,
            default(){
                return {
                    action: 'create',
                };
            },
        }
    },
    watch: {
        shown(value) {
            this.action = this.modus.action;
            this.loadMk();
            if(value === false) {
                this.reset();
            }
            else{
                this.$root.setModalHidden(false);

                if(this.action == 'edit'){

                    this.load();
                }
            }
            this.showModal = value;
        },
        showModal(value) {
            this.$emit('update:shown', value);
        }
    },
    computed:{
        description:{
            set(value){
              this.article.descriptions[this.selectedLanguage].description = value;
            },
            get(){
              if(!this.article || !this.article.descriptions) return null;

              return this.article.descriptions[this.selectedLanguage].description;
            }
        },
        shortdesc:{
          set(value){
            this.article.descriptions[this.selectedLanguage].shortdesc = value;
          },
          get(){
            if(!this.article || !this.article.descriptions) return null;

            return this.article.descriptions[this.selectedLanguage].shortdesc;
          }
        },
        title:{
          set(value){
            this.article.descriptions[this.selectedLanguage].title = value;
          },
          get(){
            if(!this.article || !this.article.descriptions) return null;

            return this.article.descriptions[this.selectedLanguage].title;
          }
        },
        usedAttributeIds() {
          if(!this.article.attributes) return [];
          return this.article.attributes.map(attr => attr.attribute_id);
        },
        priceA(){
            return this.article.vkMin * 1.05;
        },
        priceB(){
            return this.article.vkMinBH * 1.05;
        },
        priceC(){
            return (this.priceA - this.priceB) / 2 + this.priceB;
        },
        isManuelKeySelectionByAmountActive: {
            get(){
                return this.article.manuelKeySelectionByAmount && this.article.manuelKeySelectionByAmount > 0;
            },
            set(value){
                if(value){
                  this.article.manuelKeySelectionByAmount = 1;
                }
                else{
                  this.article.manuelKeySelectionByAmount = null;
                }
            }
        },
    },
    data() {
        return {
            action: 'create',
            selectedLanguage: 'de',
            showModal: false,
            errors: [],
            saving: false,
            article: {},
            mediakits: [],
            html: '<p>Hallo <strong>Welt</strong>!</p>',
            toolbarOptions: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['link', 'image', 'code-block'],
              [{ align: [] }],
              ['clean'],
            ],
            options: {
              "currency": "EUR",
              "currencyDisplay": "hidden",
              "precision": 0,
              "hideCurrencySymbolOnFocus": true,
              "hideGroupingSeparatorOnFocus": true,
              "hideNegligibleDecimalDigitsOnFocus": true,
              "autoDecimalDigits": false,
              "useGrouping": true,
              "accountingSign": false
            },
            articleDefault:{
                isActive: false,
                mediakit_id: null,
                artnr: '',
                title: '',
                version: '',
                producer: '',
                vkMin: 0.00,
                vkMinHB: 0.00,
                priceEK: 0.00,
                stockWarning: 0,
                manuelKeySelection: false,
                manuelKeySelectionByAmount: null,
                autostopAmountSmallerThan: false,
                pdf_standard: false,
                pdf_cal: false,
                pdf_installation: false,
                isKmsPossible: false,
                minLicensce: 1,
                noKeyRequired: false,
                notice: null,
                commissionable: false,
                category_id: null,
                customerReferenceNumber: '',
            }
        };
    },
    mounted() {
        this.article = {...this.articleDefault};
        this.showModal = this.shown;
    },
    methods:{
        reset(){
            this.errors = {};
            this.article = {...this.articleDefault};
        },
        isUsedOption(id, currentId) {
          id = Number(id);
          currentId = Number(currentId);
          return id != currentId && this.usedAttributeIds.includes(id);
        },
        addRow(){
            this.article.attributes.push({category_id: null, languages: {de: '', en: '', fr: '', it: '', pt: ''}});
        },
        removeRow(index){
            this.article.attributes.splice(index, 1);
        },
        loadMk(){
          let url = "/erp/articles/mediakits";

          this.axios.get(url).then(res => {
            this.mediakits = res.data;
          });
        },
        load(){
            let url = "/erp/articles/" + this.modus.article_id;

            this.axios.get(url).then(res => {
                this.article = res.data;
            });
        },
        create(){
          let url = "/erp/articles";
          this.errors = {};

          this.axios.post(url, this.article).then(res => {
            eventBus.$emit('article', {action: "update",  data: res.data.article});
            if(res.data.success){
              this.$toast.success('Artikel' + res.data.article.title.toString() + ' angelegt');
              this.$router.push({name: 'article', params: {id : res.data.article.id}});
              this.showModal = false;
            }
            this.reset();
          }).catch(error => {
            if (error.response && error.response.status === 422) {
              this.errors = error.response.data.errors || {};
              this.$toast.error(this.$t('common.inputError'));
            }
            else{
              this.$toast.error(this.$t('common.error'));
            }
            this.saving = this.savingNext = false;
          });

        },
        save(){
            let url = "/erp/articles/" + this.modus.article_id;
            this.errors = {};

            this.axios.put(url, this.article).then(res => {
                if(res.data.success === true){
                    this.$toast.success(this.$t('article.msg.updated', {articlename: this.article.title}));
                    eventBus.$emit('article', {action: "update",  data: res.data.data});
                    this.showModal = false;
                    this.reset();
                }
            })
            .catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                    this.$toast.error(this.$t('common.inputError'));
                }
                else{
                    this.$toast.error(this.$t('common.error'));
                }
                this.saving = this.savingNext = false;
            });
        }
    }
}
</script>

<style scoped>

</style>